import { useState } from "react";
import { Card } from '@mui/material';
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MessageError from "../../../../../../messages/messageError";
import ButtonLeft from "../../../../../../utils/buttonLeft";
import HeaderGestorConfigs from "../../../../../../utils/headerGestorConfigs";
import { createOptionsAutorizacao } from "../../../../../../services/autorizacao.service";


export default function CreateOptionsAutorizacao({ tipoEstabelecimento, empresa }) {
    const dispatch = useDispatch()
    const [opcao, setOpcao] = useState({
        tipoEstabelecimento,
        descricao: ''
    })
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false);
    const [openModal, setLoadModal] = useState(false);
    const user = useSelector(state => state.account.user);

    function handleChange(e) {
        setOpcao((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }


    const submit = async () => {
        setLoad(true)
        setMessageError('')
 
        try {
            await createOptionsAutorizacao({
                ...opcao,
                userId: user?._id
            });

            setLoadModal(false)
            dispatch({
                type: 'alert',
                payload: { alert: 'Opção criada com sucesso!' },
            });

        } catch (err) {
            // console.error(err);
            setMessageError(err.response.data.message)
        } finally {
            setLoad(false);
        }
    }


    return (
        <>
            <ButtonLeft funcao={() => setLoadModal(!openModal)} title={'Criar Opção'} />

            <Modal
                open={openModal}
                // onClose={() => setLoadModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                // scroll={'body'}
                sx={{ margin: 2, overflowY: "auto" }}
            >
                <Card style={{ padding: 25, maxWidth: 800, margin: 'auto' }}>
                    {messageError && <MessageError message={messageError} />}

                    <HeaderGestorConfigs title={`Criar nova opção de Autorização para ` + tipoEstabelecimento} />

                    <Box sx={{ mt: 2 }}>
                        <Typography m={2}>
                            Autoriza a empresa <b>{empresa}</b> a exercer a
                            actividade de <b>{opcao.descricao}</b>,
                        </Typography>
                    </Box>

                    <TextField
                        // autoFocus
                        id="inputObs"
                        style={{ marginTop: 10, }}
                        label="Descrever"
                        fullWidth
                        size="small"
                        multiline
                        minRows={3}
                        name="descricao"
                        variant="outlined"
                        defaultValue={opcao.descricao}
                        onChange={handleChange}
                    />

                    <ButtonLeft
                        title={'Salvar'}
                        funcao={submit}
                        load={load}
                    >
                        <Button onClick={() => setLoadModal(false)} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button>
                    </ButtonLeft>

                </Card>
            </Modal>
        </>
    )
}